import { CylinderGeometry, Group, Material, Matrix4, Mesh, SphereGeometry, Vector3 } from "three";
import * as Maths3 from "oc-threejs/Maths3";

/**
 * Ein 3D-Kabel, das in geraden Teilstrecken läuft
 */
export class Cable extends Group {
  cableRadius: number;
  material: Material;
  path: Vector3[];
  cylinderGeometry: CylinderGeometry;
  sphereGeometry: SphereGeometry;
  parts: { cable: Mesh; sphere: Mesh }[];

  constructor(
    path: Vector3[],
    material: Material,
    cableRadius: number,
    radialSegments = 6,
    sphereSegments = 6
  ) {
    super();
    this.cableRadius = cableRadius;
    this.material = material;
    this.cylinderGeometry = new CylinderGeometry(cableRadius, cableRadius, 1, radialSegments);
    this.cylinderGeometry.applyMatrix4(new Matrix4().makeRotationX(Math.PI / 2));
    this.sphereGeometry = new SphereGeometry(cableRadius, sphereSegments, sphereSegments);

    this.parts = [];
    path = Maths3.removeCollinearPoints(path, 0.0001);
    for (let i = 0; i < path.length - 1; i++) {
      const start = path[i];
      const end = path[i + 1];

      let part = this.parts[i];
      if (!part) {
        part = {
          cable: new Mesh(this.cylinderGeometry, this.material),
          sphere: new Mesh(this.sphereGeometry, this.material),
        };
        this.add(part.cable);
        this.add(part.sphere);
        this.parts[i] = part;
      }

      const length = start.distanceTo(end);
      part.cable.scale.z = length;
      part.cable.position.copy(start).add(end).divideScalar(2);
      part.cable.lookAt(end);

      part.sphere.position.copy(end);
    }
  }
}
